import {
	bettingSplitsConfigFactory,
	bettingSplitsIndex,
} from './betting-splits';
import { positiveEvConfigFactory, positiveEvIndex } from './positive-ev';
import { type BettingInsightsConfigFactoryMap } from './types';

export const bettingInsightsIndexes = [bettingSplitsIndex, positiveEvIndex];

export const configFactoryMap: BettingInsightsConfigFactoryMap = {
	[bettingSplitsIndex]: bettingSplitsConfigFactory,
	[positiveEvIndex]: positiveEvConfigFactory,
};
